import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Grid, Typography, Button } from "@material-ui/core";
import { BUTTON_COLOR, TEXT_COLOR } from "../utils/constant";
import {
  addToCart,
  addQuantity,
  subtractQuantity,
} from "../store/actions/cartActions";

const SuggestedItemButton = function (props) {
  const {
    lineItem,
    setSelectedItem,
    setModifierPopup,
    setIsRepeatation,
    storeInfo,storeInfoConfig,
    isDisabled,
    setAction,
  } = props;

  const dispatch = useDispatch();
  const cartProps = useSelector((state) => state.cartReducer);

  let primaryColor =  storeInfoConfig?.general_config?.primary_color;
  let secondaryColor =  storeInfoConfig?.general_config?.secondary_color;

  const addQty = (item) => {
    dispatch(addQuantity(item));
  };

  const removeQty = (item) => {
    dispatch(subtractQuantity(item));
  };

  const addToCartItem = (item) => {
    dispatch(addToCart(item));
  };

  const handleAddButton = (item) => {
    setSelectedItem(item);
    if (
      item.item_variant?.length > 1 ||
      (item.item_variant[0]?.item_addons?.length &&
        !item.item_variant[0]?.item_addons.includes(""))
    ) {
      setModifierPopup(true);
    } else {
      addToCartItem(item);
    }
  };

  const getAddedItemQty = (id) => {
    const cartItem = cartProps?.addedItems?.filter((e) => e?._id === id);
    let q = 0;
    for (let i = 0; i < cartItem?.length; i++) {
      q = q + cartItem[i].quantity;
    }
    return q;
  };

  const checkAddedItem = (id) => {
    const cartItem = cartProps?.addedItems?.find((e) => e?._id === id);
    return cartItem ? true : false;
  };

  return checkAddedItem(lineItem?._id) ? (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        alignContent: "flex-end",
        flexWrap: "wrap",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          float: "right",
          display: "flex",
          padding: "0px 5px",
          justifyContent: "space-evenly",
          alignContent: "center",
          alignItems: "center",
          border: "0.5px solid #d4d4d4",
          minWidth: "6rem",
          borderRadius: "0.6rem",
          backgroundColor:primaryColor|| BUTTON_COLOR,
        }}
      >
        <Grid container xs={4} sm={4} md={4} lg={4}>
          <RemoveIcon
            style={{
              color:  "white"  || TEXT_COLOR,
              backgroundColor:primaryColor|| BUTTON_COLOR,
              height: "25px",
              width: "15px",
              borderRadius: "8px 0rem 0rem 8px",

              // padding: "0rem 0.3rem",
            }}
            onClick={() =>
              lineItem.item_variant?.length > 1 ||
              lineItem.item_variant[0]?.item_addons?.length
                ? (setIsRepeatation(true),
                  setSelectedItem(lineItem),
                  setAction(1))
                : removeQty(lineItem)
            }
            // onClick={() => removeQty(lineItem?.item_variant[0]._id)}
          />
        </Grid>
        <Grid
          xs={4}
          sm={4}
          md={4}
          lg={4}
          style={{
            color:  "white"  || TEXT_COLOR,
            backgroundColor:primaryColor|| BUTTON_COLOR,
            height: "25px",
            borderRadius: "8px 0rem 0rem 8px",

            // padding: "0rem 0.3rem",
          }}
        >
          <Typography>
            <span
              style={{
                fontSize: "1rem",
                color: "white",
                fontWeight: "700",
              }}
            >
              {getAddedItemQty(lineItem?._id)}
            </span>
          </Typography>
        </Grid>
        <Grid container justifyContent="flex-end" xs={4} sm={4} md={4} lg={4}>
          <AddIcon
            style={{
              height: "25px",
              width: "15px",
              color:  "white"  || TEXT_COLOR,
              backgroundColor:primaryColor|| BUTTON_COLOR,
              borderRadius: "8px 0rem 0rem 8px",
            }}
            onClick={() =>
              lineItem.item_variant?.length > 1 ||
              lineItem.item_variant[0]?.item_addons?.length
                ? (setIsRepeatation(true),
                  setSelectedItem(lineItem),
                  setAction(0))
                : getAddedItemQty(lineItem?._id)
                ? addQty(lineItem)
                : addToCartItem(lineItem)
            }
          />
        </Grid>
      </Grid>
      <Grid>
        {lineItem.item_variant?.length > 1 && (
          <Typography>
            <span
              style={{
                fontSize: "0.9rem",
                fontWeight: "500",
                color: "#212121",
                fontFamily: "Satoshi, sans-serif",
              }}
            >
              Customise
            </span>
          </Typography>
        )}
      </Grid>
    </Grid>
  ) : (
    <>
      <Grid>
        <Grid>
          <Button
            disabled={isDisabled}
            onClick={() => handleAddButton(lineItem)}
            variant="contained"
            style={{
              float: "right",
              minWidth: "6rem",
              maxHeight: "2rem",
              borderRadius: "0.6rem",
              fontSize: "14px",
              // color: secondaryColor || TEXT_COLOR,
              // backgroundColor:primaryColor|| BUTTON_COLOR,
              backgroundColor: "white",
              color:primaryColor|| BUTTON_COLOR,
            }}
          >
            Add
          </Button>
        </Grid>{" "}
        <Grid>
          {lineItem.item_variant?.length > 1 && (
            <Typography>
              <span
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "500",
                  color: "#212121",
                  fontFamily: "Satoshi, sans-serif",
                }}
              >
                Customise
              </span>
            </Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default SuggestedItemButton;
